import moment from "moment";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { IInquiryItem } from "../../models/boardParentsQna.model";
import { createAlarm, getHeaderAlarmInquiries } from "../../api/alarm.api";
import { RootState } from "../../store/rootReducer";
import { useSelector } from "react-redux";

interface IProps {
  data: IInquiryItem;
  execute: any;
}

const Inquiry: FC<IProps> = ({
  data,
  execute
}) => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  
  const handleClick = async () => {

    await createAlarm({
      memberCode: auth.memberCode,
      alarmType: 'IQ',
      targetCode: data.qnaCode
    })
    await execute(getHeaderAlarmInquiries());
    history.push(`/homepage/inquiry/${data.qnaCode}`);
  }

  return (
    <dd>
      <span className='badge-text'>{t('common.layout.15')}</span>
      <a href='#' className='tit' onClick={handleClick}>{data.title}</a>
    </dd>
  );
}

export default Inquiry;
